var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini", icon: "el-icon-plus" },
              on: { click: _vm.showSelectDialog },
            },
            [_vm._v("添加" + _vm._s(_vm.title) + "描点")]
          ),
          _c(
            "div",
            { staticStyle: { margin: "20px 0" } },
            [
              _c(
                "vxe-table",
                {
                  ref: "xTree",
                  attrs: {
                    border: "",
                    resizable: "",
                    "show-overflow": "",
                    data: _vm.tableList,
                    "edit-config": { trigger: "click", mode: "cell" },
                  },
                },
                [
                  _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
                  _c("vxe-column", {
                    attrs: {
                      field: "x",
                      align: "center",
                      width: "70",
                      title: "x坐标",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "y",
                      align: "center",
                      width: "70",
                      title: "y坐标",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "titleCn",
                      align: "center",
                      "min-width": "100",
                      title: "中文标题",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "titleEn",
                      align: "center",
                      "min-width": "100",
                      title: "英文标题",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "descriptionCn",
                      align: "center",
                      "min-width": "100",
                      title: "中文描述",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "descriptionEn",
                      align: "center",
                      "min-width": "100",
                      title: "英文描述",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      align: "center",
                      width: "150",
                      field: "blockImage",
                      title: "图片",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.blockImage.length > 0
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "imageBox" },
                                    _vm._l(
                                      row.blockImage,
                                      function (imgItem, index) {
                                        return _c("el-image", {
                                          key: index,
                                          staticStyle: {
                                            height: "35px",
                                            width: "50px",
                                            margin: "5px",
                                          },
                                          attrs: {
                                            src: _vm.setUrlHearder(
                                              imgItem.filePath
                                            ),
                                            "preview-src-list": [
                                              _vm.setUrlHearder(
                                                imgItem.filePath
                                              ),
                                            ],
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      title: "操作",
                      align: "center",
                      width: "150",
                      "show-overflow": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("vxe-button", {
                              attrs: {
                                mode: "text",
                                disabled: _vm.disabled,
                                icon: "vxe-icon-edit",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.editEvent(row)
                                },
                              },
                            }),
                            _c("vxe-button", {
                              attrs: {
                                mode: "text",
                                disabled: _vm.disabled,
                                icon: "vxe-icon-delete",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleRemove(row)
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          staticClass: "gridDialog",
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            "append-to-body": true,
            width: "700px",
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-right": "0" }, attrs: { gutter: 15 } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("div", [
                  _c("span", { staticStyle: { "padding-left": "20px" } }, [
                    _vm._v("请点击图片进行描点，描点后编辑内容"),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      margin: "20px",
                      display: "flex",
                      "justify-content": "center",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "dotContainer",
                        staticStyle: {
                          position: "relative",
                          width: "600px",
                          height: "500px",
                        },
                      },
                      [
                        _c("el-image", {
                          staticStyle: {
                            width: "600px",
                            height: "500px",
                            cursor: "pointer",
                          },
                          attrs: { fit: "fill", src: _vm.backgroundImage },
                          on: { click: _vm.addDot },
                        }),
                        _vm._l(_vm.dots, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "point",
                              style: {
                                top: item.y + "px",
                                left: item.x + "px",
                              },
                              on: {
                                mousedown: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.onDotMouseDown($event, index)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning",
                                staticStyle: {
                                  "font-size": "24px",
                                  color: "#56d556",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(_vm._s(index + 1)),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitPoint()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          staticClass: "gridDialog",
          attrs: {
            title: "编辑锚点内容",
            "close-on-click-modal": false,
            "append-to-body": true,
            "destroy-on-close": "",
            width: "900px",
            visible: _vm.showEdit,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showEdit = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                size: "small",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { staticStyle: { "margin-right": "0" }, attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "中文标题",
                            prop: "titleCn",
                            rules: [
                              {
                                required: true,
                                message: "中文标题不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写中文标题" },
                            model: {
                              value: _vm.formData.titleCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "titleCn", $$v)
                              },
                              expression: "formData.titleCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "英文标题",
                            prop: "titleEn",
                            rules: [
                              {
                                required: true,
                                message: "英文标题不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写英文标题" },
                            model: {
                              value: _vm.formData.titleEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "titleEn", $$v)
                              },
                              expression: "formData.titleEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "中文描述",
                            prop: "descriptionCn",
                            rules: [
                              {
                                required: true,
                                message: "中文描述不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 2, maxRows: 4 },
                              placeholder: "请填写中文描述",
                            },
                            model: {
                              value: _vm.formData.descriptionCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "descriptionCn", $$v)
                              },
                              expression: "formData.descriptionCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "英文描述",
                            prop: "descriptionEn",
                            rules: [
                              {
                                required: true,
                                message: "英文描述不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 2, maxRows: 4 },
                              placeholder: "请填写英文描述",
                            },
                            model: {
                              value: _vm.formData.descriptionEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "descriptionEn", $$v)
                              },
                              expression: "formData.descriptionEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "片块图片",
                            prop: "blockImageId",
                            rules: [
                              {
                                required: true,
                                message: "片块图片不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("ImageUploadDraggable", {
                            key:
                              "blockImage_" +
                              _vm.formData.x +
                              "_" +
                              _vm.formData.y,
                            ref: "imageUploadRef",
                            attrs: {
                              limit: 1,
                              otherPrams: _vm.otherPrams,
                              action: "/unmfile/cecUnmFileupload",
                              tip: "单个图片不要超过10M",
                            },
                            on: { updateChange: _vm.handImageIds },
                            model: {
                              value: _vm.formData.blockImage,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "blockImage", $$v)
                              },
                              expression: "formData.blockImage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.showEdit = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitRow()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }